import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { TooltipOptions } from "primereact/tooltip/tooltipoptions";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { formatNumberOneDecimal } from "../../shared/reportUtil";
import { promptScoresReportLink } from "./PromptReport";
import {
	EssayPromptUsage,
	EssayUsageDetails,
	PromptUsage,
} from "./PromptUsageFilteredByCourseViewModel";

export function EssayPromptAnalysisTable(props: {
	className: string;
	courseId: number;
	promptData: EssayPromptUsage[];
	classData: EssayUsageDetails;
}) {
	const hasData = props.promptData && props.promptData.length > 0;

	const promptNameTemplate = (rowData: PromptUsage) => {
		return (
			<Link className="link" to={promptScoresReportLink(rowData.promptId, props.courseId)}>
				{rowData.promptName}
			</Link>
		);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Class" footerClassName="font-medium !text-right" />
				<Column footer={props.classData.essayCount} footerClassName="font-medium" />
				<Column footer={props.classData.draftCount} footerClassName="font-medium" />
				<Column
					footer={formatNumberOneDecimal(props.classData.averageDraftPerEssay)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.developmentOfIdeas)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.organization)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.style)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.wordChoice)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.sentenceStructure)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.conventions)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.averageScore)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	const tooltipOptions: TooltipOptions = {
		position: "top",
		showDelay: 250,
		hideDelay: 0,
	};

	return (
		<DataTable
			value={props.promptData}
			dataKey="promptId"
			loading={props.promptData == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header="Prompt"
				body={promptNameTemplate}
				sortable
				sortField="writerName"></Column>
			<Column header="Number of Essays" field="essayCount" sortable></Column>
			<Column header="Number of Drafts" field="draftCount" sortable></Column>
			<Column header="Avg # of Drafts" field="averageDraftPerEssay" sortable></Column>
			<Column
				header="Dev"
				field="developmentOfIdeas"
				sortable
				headerTooltip="Development of Ideas"
				headerTooltipOptions={tooltipOptions}></Column>
			<Column
				header="Org"
				field="organization"
				sortable
				headerTooltip="Organization"
				headerTooltipOptions={tooltipOptions}></Column>
			<Column
				header="Style"
				field="style"
				sortable
				headerTooltip="Style"
				headerTooltipOptions={tooltipOptions}></Column>
			<Column
				header="WC"
				field="wordChoice"
				sortable
				headerTooltip="Word Choice"
				headerTooltipOptions={tooltipOptions}></Column>
			<Column
				header="Sent"
				field="sentenceStructure"
				sortable
				headerTooltip="Sentence Structure"
				headerTooltipOptions={tooltipOptions}></Column>
			<Column
				header="Conv"
				field="conventions"
				sortable
				headerTooltip="Conventions"
				headerTooltipOptions={tooltipOptions}></Column>
			<Column
				header="Avg Score"
				field="averageScore"
				sortable
				headerTooltip="Average Score"
				headerTooltipOptions={tooltipOptions}></Column>
		</DataTable>
	);
}
